import { gql, useMutation } from '@apollo/client';
import { GET_KWP_CONNECTION_INFO_QUERY } from './get-kwp-connection.hook';

const UPDATE_CONNECTION_TO_KWP = gql`
  mutation updateInterface($payload: InterfaceInput!) {
    updateInterface(payload: $payload) {
      _id
      interfaceName
      createdBy
      link
      codeVerifier
      codeChallenge
    }
  }
`;

export const useUpdateKWPConnection = () => {
  const [mutate, { data, loading }] = useMutation(UPDATE_CONNECTION_TO_KWP, {
    refetchQueries: [GET_KWP_CONNECTION_INFO_QUERY],
  });

  return {
    updateConnection: mutate,
    data,
    loading,
  };
};
